export default "__VITE_ASSET__DinNl8tT__"